module.exports = __webpack_public_path__ + "static/media/logo.ebc8ddb3.svg";